import { notify } from "@/utils/notify.js";
import i18n from "@/i18n.js"

export default function useUtilities() {
  const initData = (practice, personal, setting, old_practice, old_personal, old_setting) => {
    if (old_practice) Object.assign(practice, JSON.parse(JSON.stringify(old_practice)));
    if (old_personal) Object.assign(personal, JSON.parse(JSON.stringify(old_personal)));
    if (old_setting) Object.assign(setting, JSON.parse(JSON.stringify(old_setting)));
  }

  const valueChanged = (obj1, obj2) => {
    return JSON.stringify(obj1) != JSON.stringify(obj2)
  }

  const validateEmail = (email) => {
    if (!email) return true;
    if (email.match(
      //eslint-disable-next-line
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    )) return true;
    return false;
  };

  const maskEmail = (email) => {
    return email.replace(/^(.{1,2})?(.*?)(.?@.*$)/, '$1***$3');
  };

  const maskPhone = (phone) => {
    return phone.replace(/^(.{3})(.*)(.{2})/, '$1***$3');
  };

  const convertToZeroOne = (obj) => {
    for (let item in obj) {
      if (obj[item] === false) obj[item] = "0"
      else if (obj[item] === true) obj[item] = "1"
    }
    return obj
  }

  const copyAddress = (target, obj) => {
    Object.keys(target).forEach((key) => {
      if (key != "address_id")
        obj[key] = target[key]
    });
  };

  const mapAddress = (obj) => {
    if (obj['shipping_address']['sameAsOffice']) copyAddress(obj['office_address'], obj['shipping_address']);
    if (obj['billing_address']['sameAsOffice']) copyAddress(obj['office_address'], obj['billing_address']);
  };

  const mappingInfoToPost = (type, obj, isOld) => {
    let newobj = {}
    switch (type) {
      case "practiceInfo":
        mapAddress(obj)
        newobj = {
          ...obj,
          basic_practice_name: obj.practice_name,
          // basic_info_national_proactice_id: obj.national_practice_id,
          set_default_customer_id: obj.default_customer
        }
        for (let item in obj.office_address) {
          newobj['office_address_' + item] = obj.office_address[item]
        }
        for (let item in obj.shipping_address) {
          newobj['shipping_address_' + item] = obj.shipping_address[item]
        }
        for (let item in obj.billing_address) {
          newobj['billing_address_' + item] = obj.billing_address[item]
        }
        break;
      case "generalPerferences":
        obj.hasPatientNavigator = obj.hasNavigator;
        newobj = { ...obj }
        newobj = convertToZeroOne(newobj)
        break;
      case "notificationPerferences":
      case "patientNavigation":
        newobj = { ...obj }
        newobj = convertToZeroOne(newobj)
        break;
      case "billing":
      case "account":
      case "payoutSetting":
        newobj = { ...obj }
        break;
    }
    let oldobj = {}
    if (isOld) {
      Object.keys(newobj).forEach((key) => {
        oldobj['old_' + key] = newobj[key] ? newobj[key] : ""
      })
    }
    return isOld ? oldobj : newobj
  }

  const mappingSettingToPost = (type, setting, isOld) => {
    if (!setting || Object.keys(setting).length === 0) return {};
    let newobj = {}
    switch (type) {
      case "practiceInfo":
        newobj = {
          basic_info_apply: setting.basic_info.apply_to_all,
          basic_info_use_practice: setting.basic_info.use_practice,
          contact_info_apply: setting.contact_info.apply_to_all,
          contact_info_use_practice: setting.contact_info.use_practice,
          address_info_apply: setting.address_info.apply_to_all,
          address_info_use_practice: setting.address_info.use_practice
        }
        break;
      case "generalPerferences":
        newobj = {
          apply_favorite: setting.favorite.apply_to_all,
          apply_pomotion_feature: setting.pomotion.apply_to_all,
          apply_default_delivery_method: setting.delivery.apply_to_all,
          apply_patient_communicate_order_test: setting.patient_communicate.apply_to_all,
          apply_favorite_use_practice: setting.favorite.use_practice,
          apply_pomotion_use_practice: setting.pomotion.use_practice,
          apply_default_delivery_method_use_practice: setting.delivery.use_practice,
          apply_patient_communicate_order_test_pomotion_use_practice: setting.patient_communicate.use_practice,
          apply_auto_delete_draft: setting.auto_delete_draft.apply_to_all,
          apply_delete_draft_after_use_use_practice: setting.auto_delete_draft.use_practice,
          apply_pn: setting.hasNavigator.apply_to_all,
          apply_pn_use_practice: setting.hasNavigator.use_practice,
          apply_express_checkout: setting.express_checkout.apply_to_all,
          apply_express_checkout_use_practice: setting.express_checkout.use_practice,
          apply_optInAutomaticRedraw: setting.optInAutomaticRedraw.apply_to_all,
          apply_optInAutomaticRedraw_use_practice: setting.optInAutomaticRedraw.use_practice,
          apply_personalizedReport: setting.personalized_report.apply_to_all,
          apply_personalizedReport_use_practice: setting.personalized_report.use_practice,
          apply_restrict_support_disclosure_order_info: setting.restrict_support_disclosure_order_info.apply_to_all,
          apply_restrict_support_disclosure_order_info_use_practice: setting.restrict_support_disclosure_order_info.use_practice
        }
        break;
      case "notificationPerferences":
        newobj = {
          apply_patient_communication: setting.patient_communication.apply_to_all,
          apply_patient_communication_use_practice: setting.patient_communication.use_practice,
          apply_notify_me: setting.notify_me.apply_to_all,
          apply_notify_me_use_practice: setting.notify_me.use_practice,
          apply_patient_communicate_order_test: setting.patient_notification.apply_to_all,
          apply_patient_communicate_order_test_pomotion_use_practice: setting.patient_notification.use_practice
        }
        break;
      case "billing":
        newobj = {
          apply_patient_communication_billing: setting.patient_communication_billing.apply_to_all,
          apply_patient_communication_billing_use_practice: setting.patient_communication_billing.use_practice,
          apply_payment_method: setting.payment_method.apply_to_all,
          apply_payment_method_use_practice: setting.payment_method.use_practice,
          apply_billing_consultation_fee: setting.billing_consultation_fee.apply_to_all,
          apply_billing_consultation_fee_use_practice: setting.billing_consultation_fee.use_practice,
          apply_payout_method: setting.billing_payout_method.apply_to_all,
          apply_payout_method_use_practice: setting.billing_payout_method.use_practice
        }
        break;
      case "patientNavigation":
        newobj = {
          apply_pns: setting.pns.apply_to_all,
          apply_pns_use_practice: setting.pns.use_practice,
        }
    }
    let oldobj = {}
    if (isOld) {
      Object.keys(newobj).forEach((key) => {
        oldobj['old_' + key] = newobj[key]
      })
    }
    return isOld ? oldobj : newobj
  }

  const transformPayloadForPost = (type, new_data, old_data) => {
    let newobj = { ...mappingInfoToPost(type, new_data, false), ...mappingInfoToPost(type, old_data, true) }
    for (let item in newobj) {
      if (newobj[item] === undefined) newobj[item] = ""
    }
    if (type === 'practiceInfo') {
      //keep npi unchanged
      newobj.basic_info_national_proactice_id = old_data.national_practice_id;
      newobj.old_basic_info_national_proactice_id = old_data.national_practice_id;
      //keep address id unchanged
      newobj.old_office_address_address_id = old_data.office_address.address_id;
      newobj.old_shipping_address_address_id = old_data.shipping_address.address_id;
      newobj.old_billing_address_address_id = old_data.billing_address.address_id;
      newobj.office_address_address_id = newobj.old_office_address_address_id;
      newobj.shipping_address_address_id = newobj.old_shipping_address_address_id;
      newobj.billing_address_address_id = newobj.old_billing_address_address_id;
      newobj.office_address.address_id = newobj.old_office_address_address_id;
      newobj.shipping_address.address_id = newobj.old_shipping_address_address_id;
      newobj.billing_address.address_id = newobj.old_billing_address_address_id;
    }
    if (type === 'generalPerferences') {
      newobj.personalizedReportPreferenceList = mergeReportResult(newobj.old_personalizedReportPreference, newobj.personalizedReportPreference)
      delete newobj.old_personalizedReportPreference;
      delete newobj.personalizedReportPreference;
    }
    return newobj
  }

  const mergeReportResult = (oldArray, newArray) => {
    const mergedArray = oldArray.map(oldItem => {
      const newItem = newArray.find(item => item.name === oldItem.name);
      return {
        name: oldItem.name,
        old_value: oldItem.value,
        value: newItem ? newItem.value : "0"
      };
    });
    newArray.forEach(newItem => {
      if (!mergedArray.some(item => item.name === newItem.name)) {
        mergedArray.push({
          name: newItem.name,
          old_value: "0",
          value: newItem.value
        });
      }
    });
    return mergedArray
  }

  const notifySuccess = (msg = i18n.global.t("SettingPage[\"Saved\"]")) => {
    notify({
      title: i18n.global.t("SettingPage[\"Success\"]"),
      message: msg,
      type: "success",
      duration: 8000
    });
  }

  const notifyFailure = (msg = i18n.global.t("SettingPage[\"Please try again.\"]")) => {
    notify({
      title: i18n.global.t("SettingPage[\"Failed\"]"),
      message: msg,
      type: "error",
      duration: 8000
    });
  }

  const formattedPhone = (phone) => {
    // Remove all non-numeric characters from the input
    let cleaned = phone.replace(/[^0-9]/g, "");
    // xxx-xxx-xxxx
    if (cleaned.length > 3) {
      cleaned = cleaned.slice(0, 3) + "-" + cleaned.slice(3);
    }
    if (cleaned.length > 7) {
      cleaned = cleaned.slice(0, 7) + "-" + cleaned.slice(7);
    }
    return cleaned;
  }

  const getCountryShortName = (country, countries) => {
    if (!country || !country.trim()) return "";
    if (country.length === 2) return country.toUpperCase();
    let res = countries?.filter(c => c.countryName === country)
    if (res?.length > 0) return res[0].countryNameTwoBytes
  }

  function capitalizeString(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function getUserFullName(firstName, lastName) {
    if (!firstName && !lastName) {
      return "";
    }
    if (!firstName) {
      return capitalizeString(lastName);
    }
    if (!lastName) {
      return capitalizeString(firstName);
    }
    return [capitalizeString(firstName), capitalizeString(lastName)]
      .join(" ");
  }

  return { initData, valueChanged, validateEmail, transformPayloadForPost, notifySuccess, notifyFailure, maskEmail, maskPhone, formattedPhone, copyAddress, getCountryShortName, getUserFullName }
}